import { useContext } from "react";
import { VideoEditorContext } from "../App";

/**
 * Custom hook to reset any active scene when clicking outside toolbar components.
 */
const useResetActiveScene = () => {
  const { handleChangeActiveObject } = useContext(VideoEditorContext);

  const resetActiveScene = () => {
    handleChangeActiveObject(NaN);
  };
  return { resetActiveScene };
};

export default useResetActiveScene;
